import { Search, X } from "lucide-react";
import { FILTERS } from "@/constants/testIds";

const pillClass = (active) =>
  `shrink-0 font-mono text-[10px] sm:text-xs uppercase tracking-widest px-3 min-h-[44px] flex items-center border transition-colors ${
    active ? "border-[#CCFF00] text-[#CCFF00]" : "border-[#2A2A2A] text-[#888880] hover:text-[#F5F5F0] hover:border-[#555550]"
  }`;

export const FilterBar = ({
  categories,
  types,
  activeCategory,
  activeType,
  search,
  onCategory,
  onType,
  onSearch,
  onClear,
  totalCount,
}) => {
  const hasActive = activeCategory !== "all" || activeType !== "all" || search.trim() !== "";
  return (
    <div className="w-full border-b border-[#2A2A2A] bg-[#101010]">
      <div className="max-w-[1600px] mx-auto px-3 sm:px-6 py-2.5 sm:py-3 flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-1.5 overflow-x-auto no-scrollbar shrink-0" aria-label="Category filters">
          <button type="button" data-testid={FILTERS.categoryAll} onClick={() => onCategory("all")} className={pillClass(activeCategory === "all")}>
            All [{totalCount}]
          </button>
          {categories.map((c) => (
            <button key={c.name} type="button" data-testid={FILTERS.categoryPill(c.name)} onClick={() => onCategory(c.name)} className={pillClass(activeCategory === c.name)}>
              {c.name} [{c.count}]
            </button>
          ))}
        </div>
        <div
          className="flex items-center gap-1.5 overflow-x-auto no-scrollbar shrink-0 sm:border-l sm:border-[#2A2A2A] sm:pl-3"
          aria-label="Production type filters"
        >
          {types.map((t) => (
            <button key={t.name} type="button" data-testid={FILTERS.typePill(t.name)} onClick={() => onType(t.name)} className={pillClass(activeType === t.name)}>
              {t.name} [{t.count}]
            </button>
          ))}
        </div>
        <div className="flex items-center gap-2 flex-1 min-w-[220px]">
          <div className="relative flex-1 min-w-[220px]">
            <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#555550]" />
            <input
              type="text"
              value={search}
              onChange={(e) => onSearch(e.target.value)}
              placeholder="Search keywords, brand…"
              data-testid={FILTERS.searchInput}
              className="w-full bg-[#181818] border border-[#2A2A2A] focus:border-[#CCFF00] outline-none font-mono text-xs uppercase tracking-wider text-[#F5F5F0] placeholder:text-[#555550] pl-8 pr-3 min-h-[44px] transition-colors"
            />
          </div>
          {hasActive && (
            <button
              type="button"
              data-testid={FILTERS.clearAll}
              onClick={onClear}
              className="shrink-0 flex items-center gap-1 font-mono text-[10px] sm:text-xs uppercase tracking-widest px-3 min-h-[44px] text-[#888880] hover:text-[#CCFF00] transition-colors"
            >
              <X size={12} /> Clear
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
